import { render, staticRenderFns } from "./indType-add.vue?vue&type=template&id=d32bdf42&scoped=true&"
import script from "./indType-add.vue?vue&type=script&lang=js&"
export * from "./indType-add.vue?vue&type=script&lang=js&"
import style0 from "./indType-add.vue?vue&type=style&index=0&id=d32bdf42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32bdf42",
  null
  
)

export default component.exports